<template>
  <div class="content-box finacial-detail-list-page">
    <div class="page-title page-title--center">
      <div class="page-title__main">{{pageTitle}}</div>
      <div class="page-title__sub">
        <span>{{startDate}}</span>
        <span>至</span>
        <span>{{endDate}}</span>
      </div>
    </div>
    <div class="finacial-search search">
      <page-search
        :layout="searchLayout"
        :searchList="searchList"
        @search="search"
      ></page-search>
    </div>
    <div class="page-table-box yjh-finacial-detail-list">
      <pageTable
        ref="finacialTable"
        class="yjh-finacial-flow--detail"
        :loading="tableLoading"
        :col="col"
        :data="tableData"
        :total="total"
        :isVerticalResize="true"
        :showVerticalBorder="true"
        :showHorizontalBorder="true"
        :showTrBack="false"
        :pageSize="pageSize"
        :pageIndex="page"
        @pageChange="pageChange"
        @pageSizeChange="pageSizeChange"
      ></pageTable>
    </div>
  </div>
</template>
<script>
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import pageSearch from '@/components/pageCom/pageSearch'

import { finacialDetail } from '@/api/report' // eslint-disable-line

export default {
  components: { pageTable, pageSearch },
  mixins: [pageTableMixin],
  data() {
    return {
      // 账单明细title
      pageTitle: '账务明细日账单',
      startDate: '',
      endDate: '',
      params: {
        payer: '',
        receiver: '',
        type: []
      },
      searchLayout: ['payer', 'payee'],
      searchList: [{
        name: 'feeType',
        type: 'select',
        label: '类型',
        arr: [],
        multi: true,
        optList: [
          { name: '充值', value: 'R' },
          { name: '付款', value: '2' },
          { name: '退款', value: '10' },
          { name: '收款', value: '1' },
          { name: '提现', value: 'W' }
        ]
      }]
    }
  },
  computed: {
    type() {
      return this.$route.params.type || 'day'
    },
    date() {
      return this.$route.params.date
    },
    col() {
      const tmp = [
        { field: 'caiwu_num', title: '财务流水单号', width: 140 },
        { field: 'yewu_num', title: '业务流水单号', width: 120 },
        { field: 'payer', title: '付款方名称', width: 175 },
        { field: 'receiver', title: '收款方名称', width: 175 },
        { field: 'receive_money', title: '收入金额', width: 110 },
        { field: 'pay_money', title: '支出金额', width: 110 },
        { field: 'balance', title: '账户余额', width: 110 },
        { field: 'type', title: '类型', width: 50, formatter: function(rowData, rowIndex, pagingIndex, field) {
          const value = rowData[field]
          if (Number(value) === 2 || Number(value) === 9) {
            return '付款'
          } else if (Number(value) === 1) {
            return '收款'
          } else if (Number(value) === 10) {
            return '<span class="red">退款</span>'
          } else if (value === 'W') {
            return '提现'
          } else if (value === 'R') {
            return '充值'
          }
        } },
        { field: 'jy_date', title: '交易日期', width: 160 }
      ]
      return tmp.map(item => {
        item.isResize = true
        item.titleAlign = 'left'
        item.columnAlign = 'left'
        item.overflowTitle = true
        return item
      })
    }
  },
  mounted() {
    let showDate = ''
    if (this.type === 'month') {
      this.pageTitle = '账务明细月账单'
      showDate = this.date.substring(0, 4) + '-' + this.date.substring(4, 6)
    } else {
      showDate = this.date.substring(0, 4) + '-' + this.date.substring(4, 6) + '-' + this.date.substring(6, 8)
    }
    this.$store.commit('SET_RETURN_TITLE', '账务明细（' + showDate + '）')
    this.$store.commit('SET_RETURN_TYPE', 'large')
    this.$store.commit('SET_RETURN_FULLURL', '/finacial/trade-flow/' + this.type)
  },
  methods: {
    // 切页面初始化
    initPage() {
      this.getData()
    },
    search(req) {
      this.page = 1
      this.params.payer = req.payer
      this.params.receiver = req.payee
      this.params.type = req.feeType
      this.getData()
    },
    // 获取数据
    getData() {
      this.tableLoading = true
      finacialDetail({
        page_position: this.type, // 在月统计时传month， 日统计时传day
        date: this.$route.params.date, // month时传年月(201909)，day时传年月日(20190924)
        cp: this.page, // 页码
        rp: this.pageSize, // 每页数量
        payer: this.params.payer, // 付款方名称（完全匹配）
        receiver: this.params.receiver, // 收款方名称（完全匹配）
        type: this.params.type // W: 提现; R: 充值; 2和9: 付款; 1: 收款; 10: 退款
      }).then(res => {
        this.tableLoading = false
        this.startDate = ''
        this.endDate = ''
        if (res.code !== 0) {
          this.$Message.info(res.msg)
          return
        }
        this.startDate = res.result.start_date
        this.endDate = res.result.end_date
        this.tableData = res.result.list
        this.total = res.result.count
      })
    }
  }
}
</script>
<style lang="scss" scoped="">
  @import "@/styles/color.scss";
</style>
<style lang="scss">
  @import "@/styles/color.scss";
  .finacial-detail-list-page {
    .v-table-header:before {
      height: 50px;
    }
    .page-table-box .v-table-header-inner tr td {
      border-bottom: 0;
    }
  }
</style>
